import FlagProvider from '@unleash/proxy-client-react';
import { useTypedSelector } from '../../redux/hooks';
import { selectAccountId, selectCurrentUserId } from '../../redux/slices';
import { isPreview } from '../../helpers';

const keys = {
    development: 'default:development.b670e1ed0b65ed5d197b0301dbc1c07589a50658b76c43b40de3a090',
    production: 'default:production.1317544a5a334adaefb910ebff67c337dde17c9c97a0f57c8853e325'
};

export default function FeatureContext({ children }: { children: React.ReactNode }) {
    const accountId = useTypedSelector(selectAccountId);
    const userUuid = useTypedSelector(selectCurrentUserId);

    if (!accountId) return null;

    return (
        <FlagProvider
            config={{
                refreshInterval: 60,
                appName: 'desktop-app',
                clientKey: isPreview ? keys.development : keys.production,
                url: 'https://ff.yay.com/api/frontend',
                context: {
                    userId: userUuid,
                    properties: {
                        resellerId: accountId?.toString()
                    }
                }
            }}
        >
            {children}
        </FlagProvider>
    );
}
